import { Skeleton } from '@mui/material';
import React from 'react';
import { ImageContainer, Wrapper } from 'app/components/topNewsModule/mainNews/mainNewsStyles';
import { SkeletonAnimation } from 'app/types/SkeletonAnimation';
export default function MainNewsSkeleton(_ref) {
  let {
    animation = SkeletonAnimation.Pulse
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    as: "div",
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MainNewsSkeleton",
    "data-sentry-source-file": "MainNewsSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    variant: "rectangular",
    as: Skeleton,
    animation: animation,
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "MainNewsSkeleton.tsx"
  }));
}